import React, { useEffect, useRef, useState } from "react";

import "./Product_vdo_preview.css";
import Product_vdo_card from "../../common-components/product_vdo_card/Product_vdo_card";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProducts,
  getAllProductsDetails,
  getOnlyProducts,
} from "../../../features/products/productsSlice";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import { useLocation } from "react-router-dom";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
// import ScrollAnimation from "react-animate-on-scroll";
import { variant_type } from "../../../utils/common";

function Product_Home({ product, text }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const productdata = useSelector((state) => state.product.allProductsDetails);
 

  const itemsPerPage = 8;

  const totalPages = useSelector((state) => state.product.total_pages_detail) || 1;
  const current_page = useSelector((state) => state.product.currentPage_detail) || 1;
  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  // const paginatedData = productdata?.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  const STEP = 8;
  const [showAll, setShowAll] = useState(false);

  const sectionRef = useRef(null);

  useEffect(() => {
    dispatch(
      getAllProductsDetails({
        page: currentPage,
        per_page: 8,
      }),
    );
  }, [dispatch, currentPage]);

  const handleToggle = () => {
    if (showAll && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setShowAll(!showAll);
  };

  const isFetching = useRef(false);
  const loading = useSelector((state) => state.product.loading);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.offsetHeight;

      if (
        scrollTop + windowHeight >= fullHeight - 300 &&
        !loading &&
        currentPage < totalPages
      ) {
        setCurrentPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, currentPage, totalPages]);

  useEffect(() => {
    if (!loading) {
      isFetching.current = false;
    }
  }, [loading]);

  return (
    <div className="Product_vdo_preview All_Time_Fav" ref={sectionRef}>
      <div className="container-fluid">
        <h4 className="heading_text">{text || "Shop Similar Collection"} </h4>

        <div className="all_prods_holder">
          {/* {products && products?.length > 0 ? ( */}
          {productdata && productdata.length > 0 ? (
            <div className="row">
              {productdata?.map((product, index) => {
                let metal;
                let size;
                let triple;
                if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Single)
                ) {
                  metal = product?.Product_Variants?.[0];
                } else if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Double)
                ) {
                  metal = product?.Product_Variants?.[0];
                  size = metal?.Double_Variants?.[0];
                } else if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Triple)
                ) {
                  metal = product?.Product_Variants?.[0];
                  size = metal?.Double_Variants?.[0];
                  triple = size?.Triple_Variants?.[0];
                }

                const activeVariant = triple || size || metal;

                return (
                  <div
                    className="col-lg-3 col-md-4 col-6 px-md-2 px-1"
                    key={product?.id || index}
                  >
                    {/* <ScrollAnimation animateIn="fadeInUp"> */}
                    <div className="product_card_holder">
                      {/* <Product_Info_Card
                          product={product}
                          id={product?.id}
                          imgSrc={
                            process.env.REACT_APP_IMG_URL + product?.image
                          }
                          vdoSrc={
                            process.env.REACT_APP_IMG_URL + product?.video
                          }
                          productName={product?.name}
                          priceText={activeVariant?.price || 0}
                          mrp={activeVariant?.mrp || 0}
                          kgText={metal?.Metal?.name}
                          savingPrice={
                            parseFloat(activeVariant?.mrp || 0) -
                            parseFloat(activeVariant?.price || 0)
                          }
                        /> */}

                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={product?.image}
                        vdoSrc={product?.image}
                        productName={product?.name}
                        prodDiscount={product?.prod_discount}
                        productDesignId={product?.design_id}
                        priceText={product?.Product_Variants?.[0].price || 0}
                        // mrp={product?.Product_Variants?.[0].price || 0}
                        // kgText={product?.Brand?.name || ""}
                        // savingPrice={
                        // parseFloat(product?.Product_Variants?.[0].mrp || 0) -
                        // parseFloat(product?.Product_Variants?.[0].price || 0)}
                      />
                    </div>
                    {/* </ScrollAnimation> */}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no_product_available_holder text-center w-100">
              <h3>No Product Available</h3>
            </div>
          )}
        </div>

        {/* <div className="pagination pagination_holder mt-4 d-flex justify-content-center align-items-center gap-2">
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lsaquo;
          </button>

       
          {[currentPage].map((page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={page === currentPage ? "active" : ""}
            >
              {page}
            </button>
          ))}

       
          {totalPages > 3 && (
            <>
              <span>...</span>

           
              <button
                onClick={() => handlePageChange(totalPages)}
                className={currentPage === totalPages ? "active" : ""}
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            &rsaquo;
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            &raquo;
          </button>
        </div> */}
      </div>
    </div>
  );
}

export default Product_Home;
